import NewAccountContent from './index.content'
import ViewAccountProvider from './index.provider'

const ViewAccountScreen: React.FC = () => {
  return (
    <ViewAccountProvider>
      <NewAccountContent />
    </ViewAccountProvider>
  )
}

export default ViewAccountScreen
